import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LinearProgress, makeStyles } from '@material-ui/core';
import moment from 'moment';
import PropTypes from 'prop-types';
import history from '../../services/history';
import { getLoggedUser, isAuthenticated } from '../../services/auth';
import Context from '../../context';
import { getPartnersClippingListByPartner as getData } from '../../services/ClippingApi';

function ClippingPartner({ location }) {
  const { setUser, setAboutCurrentPage } = useContext(Context);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const getDataIfNeeded = async () => {
    if (location.state?.clippingPartnerDetails)
      return setData(location.state.clippingPartnerDetails);

    const user = getLoggedUser();
    if (user.userGroup !== 4) return history.replace('/clipping');

    setLoading(true);
    const {data} = await getData(null,null,user.userGroup);

    const neededData = (data || []).find(
      ({ partner }) => partner.id === user.partnerId
    );
    if (!neededData && user.userGroup !== 4)
      return history.replace('/clipping');

    setData(neededData || null);
    setLoading(false);
  };
  useEffect(() => {
    if (!isAuthenticated) return history.replace('/');
    const user = getLoggedUser();
    setUser(getLoggedUser);
    setAboutCurrentPage({
      title: location.state
        ? `Clipping - ${location.state.clippingPartnerDetails.partner.fantasyName}`
        : undefined,
      buttons:
        user.userGroup !== 4
          ? [{ title: 'Voltar', pathname: '/clipping' }]
          : undefined,
    });
    getDataIfNeeded().then(() => {});
  }, []);

  return (
    <div className={classes.outerContainer}>
      <div className={classes.content}>
        <table className={classes.table}>
          <colgroup>
            <col className={classes.fitContent} />
            <col />
            <col />
            <col className={classes.fitContent} />
          </colgroup>
          <thead>
            <tr>
              <td>Capa</td>
              <td>Título</td>
              <td>Descrição</td>
              <td>Data</td>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.clippings.map(item => (
                <tr key={item.id}>
                  <td>
                    <Link
                      to={{
                        pathname: '/clippingdetails',
                        state: { clippingDetails: item },
                      }}
                    >
                      <img
                        src={item.cover}
                        alt="partner"
                        className={classes.cover}
                      />
                    </Link>
                  </td>
                  <td className={classes.partnerContainer}>
                    <div>{item.title}</div>
                    <div>
                      <Link
                        to={{
                          pathname: '/clippingdetails',
                          state: {
                            clippingDetails: item,
                            clippingPartnerDetails: data,
                          },
                        }}
                      >
                        Ver detalhes
                      </Link>
                    </div>
                  </td>
                  <td style={{ whiteSpace: 'pre-wrap' }}>{item.description}</td>
                  <td>{moment(item.date).format('DD/MM/YYYY')}</td>
                </tr>
              ))}
            {!loading && !data && (
              <tr>
                <td colSpan="4">Sem dados</td>
              </tr>
            )}
          </tbody>
        </table>
        {loading ? <LinearProgress style={{ marginTop: 30 }} /> : null}
      </div>
    </div>
  );
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '40px 45px',
  },
  table: {
    marginTop: '20px',
    whiteSpace: 'nowrap',
    border: '2px solid #30287b',
    '& td': {
      border: '2px solid #30287b',
    },
    '& thead': {
      background: '#30287b',
    },
    '& thead td': {
      fontSize: '12px',
      padding: '17px 25px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '13px',
      textTransform: 'uppercase',
    },
    '& tbody td': {
      fontSize: '14px',
      padding: '17px 25px',
      color: '#30287b',
    },
  },
  fitContent: {
    width: 'fit-content',
  },
  cover: {
    width: '150px',
    height: 'auto',
  },
  partnerContainer: {
    '& div:first-child': {
      marginBottom: '17px',
      fontWeight: '700',
    },
    '& div:last-child': {
      fontSize: '12px',
      '& a': {
        cursor: 'pointer',
        color: '#30287b',
      },
    },
  },
});
ClippingPartner.propTypes = {
  location: PropTypes.string.isRequired,
};
export default ClippingPartner;
